module.exports = "/_next/static/images/logo-trustpilot-780a3186ce1d22d22b7784b8f7c5be71.svg";